/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Endpoint_First_Request_HeadingInputs */

const en_endpoint_first_request_heading = /** @type {(inputs: Endpoint_First_Request_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Get ${i?.name} ${i?.action} in one request`)
};

const zh_hans1_endpoint_first_request_heading = /** @type {(inputs: Endpoint_First_Request_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`一个请求获取 ${i?.name} ${i?.action}`)
};

const pt_br2_endpoint_first_request_heading = /** @type {(inputs: Endpoint_First_Request_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obtenha ${i?.action} do ${i?.name} em uma só requisição`)
};

const es_endpoint_first_request_heading = /** @type {(inputs: Endpoint_First_Request_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obtén ${i?.action} de ${i?.name} en una sola solicitud`)
};

const fr_endpoint_first_request_heading = /** @type {(inputs: Endpoint_First_Request_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Obtenez ${i?.name} ${i?.action} en une requête`)
};

const de_endpoint_first_request_heading = /** @type {(inputs: Endpoint_First_Request_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} mit einer Anfrage abrufen`)
};

const ru_endpoint_first_request_heading = /** @type {(inputs: Endpoint_First_Request_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Получите ${i?.name} ${i?.action} одним запросом`)
};

const it_endpoint_first_request_heading = /** @type {(inputs: Endpoint_First_Request_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ottieni ${i?.name} ${i?.action} in una sola richiesta`)
};

/**
* | output |
* | --- |
* | "Get {name} {action} in one request" |
*
* @param {Endpoint_First_Request_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_first_request_heading = /** @type {((inputs: Endpoint_First_Request_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_First_Request_HeadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_first_request_heading(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_first_request_heading(inputs)
	if (locale === "es") return es_endpoint_first_request_heading(inputs)
	if (locale === "fr") return fr_endpoint_first_request_heading(inputs)
	if (locale === "de") return de_endpoint_first_request_heading(inputs)
	if (locale === "ru") return ru_endpoint_first_request_heading(inputs)
	if (locale === "it") return it_endpoint_first_request_heading(inputs)
	return en_endpoint_first_request_heading(inputs)
});